import { formatDate, isValidDate, parseDate } from '@luna/date';

export function formatOptionalDate(
    ...[date, ...params]: Parameters<typeof formatDate>
): ReturnType<typeof formatDate> | undefined {
    if (date === undefined || date === null) {
        return undefined;
    }

    const dateObject = date instanceof Date ? date : parseDate(date);

    if (!isValidDate(dateObject)) {
        return undefined;
    }

    return formatDate(date, ...params);
}
